<div class="title-block mb-3">
  <h4 class="card-title">{{ 'TR_FILE_LIBRARY' | translate}}</h4>
</div>

<div>
  <div *ngIf="file_library_create" class="d-inline-block">
    <button class="mb-2 mr-2 btn btn-success create-btn" title="Create template" [routerLink]="['file-library-form']">
      <i class="fa fa-plus"></i><span class="ml-2">{{ 'TR_CREATE' | translate }}</span>
    </button>
  </div>
  <hr>
  <div class="title-block mb-3">
    <h4 class="card-title">
      {{ !updateFolderId ? ('TR_CREATE_FOLDER' | translate) : ('TR_UPDATE_FOLDER' | translate) }}
    </h4>
  </div>
  <div>
    <form (submit)="submitData()" [formGroup]="form">
      <table class="align-middle mb-0 table table-striped table-hover library-component-body">
        <tbody>
          <tr>
            <td>
              <div class="d-inline-block" ngbDropdown>
                <button type="button" ngbDropdownToggle class="btn btn-primary td-drop-btn">
                  {{ selectedFolderName ? selectedFolderName : 'TR_FOLDER' | translate }}
                </button>
                <div ngbDropdownMenu>
                  <button type="button" class="dropdown-item td-drop-btn" *ngFor="let item of folders"
                    (click)="setSelectedParentLibraryData(item.id, item.name)">
                    {{ item.name }}
                  </button>
                </div>
              </div>
            </td>
            <td>
              <input type="text" name="name" [placeholder]="'TR_NAME' | translate"
                [class.error-border]="isInvalidSubmit && !form.value.name.trim()" class="form-control"
                autocomplete="off" formControlName="name" />
            </td>
            <td class="level-table-btns text-right">
              <app-save-button *ngIf="file_folder_create" [isCurrent]="true" [spinnerId]="submitSpinnerId"
                [buttonClasses]="'group-btn-padding mb-1 mr-1 btn-transition btn btn-outline-primary'"
                (submit)="submitData()"></app-save-button>
              <button *ngIf="file_folder_create" type="button"
                class="mb-1 btn-transition btn btn-outline-danger table-action-btn" [title]="'TR_CANCEL' | translate"
                (click)="cancel()">
                <i class="pe-7s-close-circle"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
  <hr>

  <ul *ngIf="list && list.length" class="file-library-accardion">
    <ng-template #folders let-list>
      <ngb-accordion #acc="ngbAccordion" *ngFor="let item of list" (panelChange)="getFileLibraryByFolderId($event)">
        <ngb-panel id={{item.id}} title={{item.name}}>

          <ng-template ngbPanelTitle>
            <div role="group" class="btn-group-sm btn-group">
              <button *ngIf="file_folder_update" class="btn-transition btn btn-outline-info"
                [title]="'TR_UPDATE' | translate" (click)="updateFolder($event, item.id, item.parentId, item.name)">
                <i class="pe-7s-note"></i>
              </button>
              <button *ngIf="file_folder_delete" class="ml-1 btn-transition btn btn-outline-danger"
                [title]="'TR_DELETE' | translate"
                (click)="confirmDeleteFolder($event, deleteconfirmFolder, item.id, item.name)">
                <i class="pe-7s-trash"></i>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div *ngIf="item.children && item.children.length > 0">
              <ng-container *ngTemplateOutlet="folders; context:{ $implicit: item.children }"></ng-container>
            </div>
            <div *ngIf="fileLibrary && fileLibrary.length">
              <div *ngFor="let i of fileLibrary">
                <div *ngIf="i.categoryId === item.id">
                  <div class="table-responsive">
                    <table class="align-middle mb-0 table table-striped table-hover">
                      <tbody>
                        <tr class="pointer">
                          <td>{{ i.name }}</td>
                          <td class="text-right">
                            <div role="group" class="btn-group-sm btn-group">
                              <button *ngIf="file_library_delete" class="ml-1 btn-transition btn btn-outline-danger"
                                [title]="'TR_DELETE' | translate"
                                (click)="confirmDeleteFile(deleteconfirmFile, i.id, i.name)">
                                <i class="pe-7s-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </ng-template>
    <ng-container *ngTemplateOutlet="folders; context:{ $implicit: list }"></ng-container>
  </ul>

  <ng-template #deleteconfirmFile let-c="close" let-d="dismiss">
    <div class="custom-modal modal-body">
      <p>{{ 'TR_DELETE_ERROR' | translate }} <b>{{ deleteFileName }}</b>?</p>
    </div>
    <div class="custom-modal modal-footer">
      <app-action-button [isCurrent]="true" [spinnerId]="deleteSpinnerId"
        buttonClasses="btn-transition btn btn-outline-info" spinnerClasses="small-button-spinner"
        [buttonName]="'TR_YES'" (clicked)="deleteFile()"></app-action-button>
      <button type="button" class="btn-transition btn btn-danger" (click)="c('Close click')">{{ 'TR_NO' | translate
        }}</button>
    </div>
  </ng-template>

  <ng-template #deleteconfirmFolder let-c="close" let-d="dismiss">
    <div class="custom-modal modal-body">
      <p>{{ 'TR_DELETE_ERROR' | translate }} <b>{{ deleteFolderName }}</b>?</p>
    </div>
    <div class="custom-modal modal-footer">
      <app-action-button [isCurrent]="true" [spinnerId]="deleteSpinnerId"
        buttonClasses="btn-transition btn btn-outline-info" spinnerClasses="small-button-spinner"
        [buttonName]="'TR_YES'" (clicked)="deleteFolder()"></app-action-button>
      <button type="button" class="btn-transition btn btn-danger" (click)="c('Close click')">{{ 'TR_NO' | translate
        }}</button>
    </div>
  </ng-template>